export const getIsAncestorDragging = (parent) => {
  if (parent.level < 0) {
    return false;
  }
  if (parent.isDragging) {
    return true;
  }
  return getIsAncestorDragging(parent.parent);
};
